import { render } from "./permissionsGroups.vue?vue&type=template&id=9c4e7ed6"
import script from "./permissionsGroups.vue?vue&type=script&lang=js"
export * from "./permissionsGroups.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__